import React, {useCallback, useEffect, useState} from 'react';
import {Depositaire, Dossier, Enlevement, Frais, Proprietaire, Sinistre} from "../../../../components/models";
import SinistreForm from "./components/SinistreForm";
import ProprietaireForm from "./components/ProprietaireForm";
import DepositaireForm from "./components/DepositaireForm";
import EnlevementForm from "./components/EnlevementForm";
import FraisForm from "./components/FraisForm";
import {useAuth} from "../../../contexts/AuthContext";

const DossierForm = (props) => {
  const {
    dossier = null,
    setFraisComplet = null,
    formatEtatChoc,
    getStatusFrais,
  }: {
    dossier?: Dossier | null,
    setFraisComplet?: any | null,
    formatEtatChoc?: any | null,
    getStatusFrais?: any | null,
  } = props;

  const {canView} = useAuth();

  const [isActive, setIsActive] = useState<string>('sinistre');
  const [sinistre, setSinistre] = useState<Sinistre | null>((dossier?.sinistres.length > 0) ? dossier.sinistres[0] : null);
  const [proprietaire, setProprietaire] = useState<Proprietaire | null>((dossier?.proprietaires.length > 0) ? dossier.proprietaires[0] : null);
  const [depositaire, setDepositaire] = useState<Depositaire | null>((dossier?.depositaires.length > 0) ? dossier.depositaires[0] : null);
  const [enlevement, setEnlevement] = useState<Enlevement | null>((dossier?.enlevements.length > 0) ? dossier.enlevements[0] : null);
  const [frais, setFrais] = useState<Frais | null>((dossier?.frais.length > 0) ? dossier.frais[0] : null);

  // Méthode de passage des données de
  // sinistre, proprietaire, depositaire, enlevement, frais
  // vers DossierGestionPage pour la completion dans la séction fixe droite qu'elles soient complète ou non
  const handleDossier = useCallback((dossier) => {
    if (!dossier) return;

    setFraisComplet(frais);
  }, [
    // sinistre,
    // proprietaire,
    // depositaire,
    // enlevement,
    frais,
    setFraisComplet
  ]);

  // useEffect pour bien mettre à jour les données de dossier à chaque enregistrement
  useEffect(() => {
    handleDossier(dossier)
  }, [dossier, handleDossier]);

  // Méthode de vérification de l'enlevement
  const handleEnlevementCompletion = () => {
    if (!enlevement || !dossier) return '';

    // Pastille rouge
    if (dossier.statut.libelle === 'Enlèvement annulé') return 'incompleted';
    // Pastille verte
    if (enlevement && enlevement.dateOuvertureDossier && enlevement.dateEnlevementEffective && enlevement.dateEntree) return 'completed';
    // Pastille orange
    else return 'in-progress';
  }

  return (
    <>
      <div className="flex items-center gap-1 p-1 border-b border-gray-100 overflow-x-auto">
        <button
          onClick={() => setIsActive('sinistre')}
          className={`tab-btn
            ${(sinistre && sinistre.immatriculation) ? 'completed' : 'incompleted'}
            ${(isActive === 'sinistre') && 'active'}
            px-3 py-2 text-xs text-gray-600 hover:text-gray-900 whitespace-nowrap rounded-lg hover:bg-gray-50 capitalize`}
        >
          Résumé
        </button>
        <button
          onClick={() => setIsActive('proprietaire')}
          className={`tab-btn
            ${(proprietaire && proprietaire.nom) ? 'completed' : 'incompleted'}
            ${(isActive === 'proprietaire') && 'active'}
            px-3 py-2 text-xs text-gray-600 hover:text-gray-900 whitespace-nowrap rounded-lg hover:bg-gray-50 capitalize`}
        >
          Propriétaire
        </button>
        <button
          onClick={() => setIsActive('depositaire')}
          className={`tab-btn
            ${(depositaire && depositaire.nom) ? 'completed' : 'incompleted'}
            ${(isActive === 'depositaire') && 'active'}
            px-3 py-2 text-xs text-gray-600 hover:text-gray-900 whitespace-nowrap rounded-lg hover:bg-gray-50 capitalize`}
        >
          Dépositaire
        </button>
        {(canView('Enlèvement') || canView('Entrée')) && (
          <button
            onClick={() => setIsActive('enlevement')}
            className={`tab-btn
              ${handleEnlevementCompletion()}
              ${(isActive === 'enlevement') && 'active'}
              px-3 py-2 text-xs text-gray-600 hover:text-gray-900 whitespace-nowrap rounded-lg hover:bg-gray-50 capitalize`}
          >
            Enlèvement
          </button>
        )}
        {(canView('Frais') || canView('Paiement & Suivi')) && (
          <button
            onClick={() => setIsActive('frais')}
            className={`tab-btn
              ${(frais && getStatusFrais(frais))}
              ${(isActive === 'frais') && 'active'}
              px-3 py-2 text-xs text-gray-600 hover:text-gray-900 whitespace-nowrap rounded-lg hover:bg-gray-50 capitalize`}
          >
            Frais
          </button>
        )}
      </div>

      {(isActive === 'sinistre') && (
        <SinistreForm
          sinistre={sinistre}
          setSinistre={setSinistre}
          formatEtatChoc={formatEtatChoc}
          // setIsActive={setIsActive}
        />
      )}
      {(isActive === 'proprietaire') && (
        <ProprietaireForm
          proprietaire={proprietaire}
          setProprietaire={setProprietaire}
          // setIsActive={setIsActive}
        />
      )}
      {(isActive === 'depositaire') && (
        <DepositaireForm
          depositaire={depositaire}
          setDepositaire={setDepositaire}
          // setIsActive={setIsActive}
        />
      )}
      {(isActive === 'enlevement') && (
        <EnlevementForm
          enlevement={enlevement}
          setEnlevement={setEnlevement}
          // setIsActive={setIsActive}
        />
      )}
      {(isActive === 'frais') && (
        <FraisForm
          frais={frais}
          setFrais={setFrais}
          // setIsActive={setIsActive}
        />
      )}
    </>
  );
}

export default DossierForm;